import './App.css';
import Home from './pages/Home';
import About from './pages/About'
import { Routes, Route } from 'react-router-dom'
import { useState } from 'react';
function App() {
  const [id, setId] = useState(null);
  console.log(id);
  return (
    <div className="App h-screen w-screen flex justify-center items-center bg-[#ececec]">
      <Routes>
        <Route path="/" element={<Home setId={setId} />} />
        <Route path='/about' element={<About id={id} />} />
      </Routes>
    </div>
  );
}

export default App;
